import axiosWithToken from "axiosWithToken";
import { DomainSetting, PreferredDomainRequestPayload } from "./types";

const baseURL2 = process.env.REACT_APP_BASEURL2;

export const saveDomainSettings = async (
  data: PreferredDomainRequestPayload
) => {
  try {
    const response = await axiosWithToken.post(
      `${baseURL2}api/organizations/domain-settings`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error saving mailbox data:", error);
    throw error;
  }
};

export const getDomainSettings = async (): Promise<DomainSetting> => {
  try {
    const response = await axiosWithToken.get<DomainSetting>(
      `${baseURL2}api/organizations/domain-settings`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching domain settings:", error);
    throw error;
  }
};
